import React, { useEffect, useRef, useState } from "react";
import "../styles/Footer.scss";
import Logo from "../assets/logo.png";
import { HiMenuAlt2 } from "react-icons/hi";
import {
  FaSquareWhatsapp,
  FaSquareInstagram,
  FaSquareFacebook,
  FaSquareGooglePlus,
} from "react-icons/fa6";

export default function Footer() {
  const footerRef = useRef();
  const [animate, setAnimate] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimate(true);
          observer.disconnect();
        }
      },
      { threshold: 0.2 }
    );
    if (footerRef.current) observer.observe(footerRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <footer className={`footer ${animate ? "visible" : ""}`} ref={footerRef}>
      <div className="footer-content">
        {/* Logo + Social */}
        <div className="footer-column logo-section">
          <img
            src={Logo}
            alt="ThermalHydro Logo"
            style={{ margin: "0 auto" }}
            className="logo"
          />
          <div
            className="social-icons"
            style={{ margin: "0 auto", marginTop: "20px" }}
            id="contacts"
          >
            <a
              href="https://www.facebook.com/profile.php?id=61566865330442"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit" }}
            >
              <FaSquareFacebook size={50} />
            </a>
            <a
              href="https://www.instagram.com/termalhydroaquecimento"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit" }}
            >
              <FaSquareInstagram size={50} />
            </a>
            <a
              href="https://wa.me/555391425203"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: "inherit" }}
            >
              <FaSquareWhatsapp size={50} />
            </a>
            <a
              href="https://g.co/kgs/aeKpqQp"
              target="_blank"
              style={{ color: "inherit" }}
            >
              <FaSquareGooglePlus size={50} />
            </a>
          </div>
        </div>

        {/* Column Links */}
        <div className="footer-column">
          <h4>Soluções</h4>
          <ul>
            <li>
              <a
                href="/products"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Produtos
              </a>
            </li>
            <li>
              <a
                href="/assistencias"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Assistências
              </a>
            </li>
            <li>
              <a
                href="/sobre-nos"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Sobre Nós
              </a>
            </li>
            <li>
              <a
                href="/services"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Serviços
              </a>
            </li>
          </ul>
        </div>
        <div className="footer-column">
          <h4>Produtos</h4>
          <ul>
            <li>
              <a
                href="/aquecedor"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Aquecedor a Gás
              </a>
            </li>
            <li>
              <a
                href="/piscina"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Coletor de Piscina
              </a>
            </li>
            <li>
              <a
                href="/boiler"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Boiler
              </a>
            </li>
            <li>
              <a
                href="/calor"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Bomba de Calor
              </a>
            </li>
            <li>
              <a
                href="/coletor"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Coletor Solar a Vácuo
              </a>
            </li>
            <li>
              <a
                href="/bomba"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Bomba de Pressurização
              </a>
            </li>
            <li>
              <a
                href="/aquaflow"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Bomba de Piscina
              </a>
            </li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Projetos</h4>
          <ul>
            <a
              href="/projects"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <li>Veja mais!</li>
            </a>
          </ul>

          <h4>Sobre a ThermalHydro</h4>
          <ul>
            <li>
              <a
                href="/termos"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Sobre a ThermalHydro
              </a>
            </li>
            <li>
              <a
                href="/clientes"
                style={{ textDecoration: "none", color: "inherit" }}
              >
                Clientes
              </a>
            </li>
          </ul>
          <a
            href="https://wa.me/555391425203"
            target="_blank"
            rel="noopener noreferrer"
            style={{ color: "inherit" }}
          >
            <button className="quote-btn">Solicite seu orçamento</button>
          </a>
        </div>
      </div>
    </footer>
  );
}
